import routes from './routes';

export default [
  {
    path: 'iniciando',
    name: 'iniciando',
    meta: { layout: 'full-page', requiereLogin: true },
    component: () => import('@/febos/global/usuario/vistas/Iniciando')
  },
  {
    path: 'verificando',
    query: { estado: '', idProceso: '' },
    name: 'verifying',
    meta: { layout: 'full-page', requiereLogin: false },
    component: () => import('@/febos/global/usuario/vistas/Verificando')
  },
  {
    path: 'verificando/claveunica',
    query: { estado: '', idProceso: '' },
    name: 'verifying.claveunica',
    meta: { layout: 'full-page', requiereLogin: false },
    component: () => import('@/febos/global/usuario/vistas/VerificandoClaveUnica')
  },
  {
    path: 'updatePassword',
    name: 'updatePassword',
    meta: { layout: 'full-page', requiereLogin: true },
    component: () => import('@/febos/global/usuario/vistas/UpdatePassword')
  },
  {
    path: 'empresas/seleccionar',
    name: 'selectorEmpresa',
    meta: { layout: 'full-page', requiereLogin: true },
    component: () => import('@/febos/global/empresas/vistas/SelectorEmpresa')
  },
  {
    path: 'verificar-qr/:febosId',
    name: 'verificar-qr',
    meta: { layout: 'full-page', requiereLogin: false },
    component: () => import('@/febos/chile/verificarQr/vistas/VerificacionQr')
  },
  {
    path: 'verificar-qr-aprobaciones/:febosId',
    name: 'verificar-qr-aprobaciones',
    meta: { layout: 'full-page', requiereLogin: false },
    component: () => import('@/febos/chile/verificarQrAprobaciones/vistas/VerificacionQrAprobaciones')
  },
  {
    path: '/',
    name: 'start',
    meta: { requiereLogin: true },
    component: () => import('@/febos/global/inicio/vistas/Inicio')
  },
  // TODO: move this to a global router.
  {
    path: 'tablero',
    name: 'board',
    meta: { permiso: 'ED069', requiereLogin: true },
    component: () => import('@/febos/global/kanban/ActivityBoard')
  },
  {
    path: 'super-tablero',
    name: 'super-board',
    meta: { permiso: 'ED070', requiereLogin: true },
    component: () => import('@/febos/global/kanban/SuperActivityBoard')
  },
  {
    path: 'usuario/perfil',
    name: 'user-profile',
    meta: { permiso: 'ED032', requiereLogin: true },
    component: () => import('@/febos/global/usuario/vistas/perfil/Perfil')
  },
  {
    path: 'configuraciones/empresa',
    name: 'settings-company',
    meta: { permiso: 'WB001', requiereLogin: true },
    component: () => import('@/febos/global/empresas/vistas/perfilEmpresa')
  },
  {
    path: 'configuraciones/usuarios',
    name: 'settings-users',
    meta: { permiso: 'WB001', requiereLogin: true },
    component: () => import('@/febos/global/empresas/vistas/gestUsuarios')
  },
  {
    path: 'configuraciones/cafs',
    name: 'settings-cafs',
    meta: { permiso: 'WB001', requiereLogin: true },
    component: () => import('@/febos/global/empresas/vistas/gestCAFs')
  },
  {
    path: 'configuraciones/parametros',
    name: 'settings-params',
    meta: { permiso: 'FEB99', requiereLogin: true },
    component: () => import('@/febos/global/empresas/vistas/ConfigParams')
  },
  {
    path: 'configuraciones/opciones',
    name: 'settings-options',
    meta: { permiso: 'FEB99', requiereLogin: true },
    component: () => import('@/febos/global/empresas/vistas/ConfigOptions')
  },
  {
    path: 'configuraciones/roles',
    name: 'settings-roles',
    meta: { permiso: 'ED237', requiereLogin: true },
    component: () => import('@/febos/global/empresas/vistas/ConfigRoles')
  },
  ...routes
];
